import React from "react";
import { Grid, Card, Typography, Box } from "@mui/material";
import { categories } from "../../../Data/data"; // Import from data.js
import { colors, fontFamilyall } from "../../../UtilColorPalate/UtilColorPalate";

const CategoryCards = () => {
  return (
    <Grid container spacing={3} mt={3}>
      {categories.map((category, index) => {
        const isEven = index % 2 === 0;
        const background = colors[index % colors.length]; // Rotate colors

        return (
          <Grid key={index} item xs={12} sm={6} md={4}>
            <Card
              sx={{
                height: { xs: "200px", sm: "250px", md: "320px" },
                backgroundImage: background,
                display: "flex",
                alignItems: "center",
                borderRadius: "18px",
                overflow: "hidden",
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.08)",
                  boxShadow: "0px 6px 25px rgba(0, 0, 0, 0.3)",
                },
                flexDirection: isEven ? "row" : "row-reverse",
              }}
            >
              {/* Text Section */}
              <Box
                sx={{
                  flex: 1,
                  padding: { xs: "15px", sm: "25px" },
                  color: "#fff",
                  textAlign: "left",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  sx={{
                    fontFamily: fontFamilyall,
                    fontSize: { xs: "20px", sm: "24px", md: "28px" },
                   
                    color: "black",

                  }}
                >
                  {category.title}
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: fontFamilyall,
                    opacity: 0.9,
                    mt: 1.5,
                    fontSize: { xs: "14px", sm: "16px" },
                   
                    color: "black",
                  }}
                >
                  {category.description}
                </Typography>
              </Box>

              {/* Image Section */}
              <Box sx={{ width: "50%", height: "100%" }}>
                <img
                  src={category.image}
                  alt={category.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderTopRightRadius: isEven ? "18px" : "0px",
                    borderBottomRightRadius: isEven ? "18px" : "0px",
                    borderTopLeftRadius: isEven ? "0px" : "18px",
                    borderBottomLeftRadius: isEven ? "0px" : "18px",
                  }}
                />
              </Box>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default CategoryCards;
